import { browserHistory } from 'react-router'
import { server } from '../../engine/server'
import { modal } from '../../utilities/modal'

var AdminTenantAccounts = Class.create({
  	initialize: function() {
  		this.server = server;
	},
	getUsers: function(callback) {
		var self = this;
		var url = "admin/tenant/management/accounts";
		// #  Send to server object for processing
		var data = self.server.getData(url,null,true);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
    },
    loginAsUser: function(userId, callback) {
        var self = this;
        var url = "admin/tenant/login/" + userId;
		var data = self.server.getData(url, null, true, 'PUT');
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
            modal.showInfo("Unable to log you into user.", "danger", "top", "center");
		});
	},
	getLatestTenants: function(callback) {
        var self = this;
        var url = "admin/tenants/latest";
		var data = self.server.getData(url, null, true);
		data
		.done(function(response){
			if (response.data.error_user_authentication == 1)
			{
			}
			else if (response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if (callback) {
                callback(response);
            }
		})
		.fail(function(e){
            modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
    },
});

export let adminTenantAccounts = new AdminTenantAccounts();


// WEBPACK FOOTER //
// app/core/controllers/Admin/AdminTenantAccounts.js